import React from "react"
import { MdAddCircle } from "react-icons/md"
import { Button, ButtonLoader } from "../../components/Button"
import { Label, SelectInput, TextArea } from "../../components/Form"
import { ActionGrid } from "../../components/List"
import { ModalBody, ModalFooter, ModalHeader, ModalPanel } from "../../components/Modal"
import "./styles.scss"

const GPTModalScreen = ({
  loading,
  onSearch,
  open,
  setOpen,
  title,
  saving,
  onSave,
  values,
  projectValues,
  setValues,
  setNewRow,
  setCopyRows,
  onSelectedRowsChange,
  selectedRows,
  handleCloseActionsModal,
  hiddenAddingButton,
  projects,
  handleChangeProject
}) => {

  const closeModal = () => {
    typeof handleCloseActionsModal === "function" ? handleCloseActionsModal() : setOpen(false)
    setValues({ actions: [] })
  }

  return (
    <>
      {!hiddenAddingButton && (
        <Button
          hasIcon={<MdAddCircle />}
          label="Adicionar"
          color="danger"
          handleClick={() => setOpen(true)}
        />
      )}
      <ModalPanel modalIsOpen={open}>
        <ModalHeader closeModal={() => closeModal()} title={title} />
        <ModalBody className="modal-gpt-content">
          {/* <TextArea
            height={85}
            width={"100%"}
            placeholder={"Digite sua busca"}
            name="description"
            resize="none"
            value={values.description}
            onChange={(event) => {
              setValues((values) => ({ ...values, description: event.target.value }))
            }}
          />
          <ButtonLoader
            loading={loading}
            messageProcess="Buscando"
            label={"Buscar"}
            // color="orange"
            handleClick={onSearch}
          /> */}
          {projects && projects?.length > 0 ? (
            <>
              <Label label="Projetos" />
              <SelectInput
                isSearchable={true}
                isClearable={true}
                isMulti={true}
                //defaultValue={values?.values?.project || ""}
                handleChange={handleChangeProject}
                options={projects}
              />
            </>
          ) : (
            <></>
          )}
          {values?.actions && (
            <ActionGrid
              checkbox={true}
              setNewRow={setNewRow}
              rows={values.actions}
              setCopyRows={setCopyRows}
              onSelectedRowsChange={onSelectedRowsChange}
            />
          )}
        </ModalBody>
        <ModalFooter className="modal-gpt-buttons">
          <Button label="Cancelar" color="danger" handleClick={() => closeModal()} />
          <ButtonLoader
            isDisabled={selectedRows?.length === 0 || projectValues?.length === 0}
            loading={saving}
            messageProcess="Salvando"
            label={"Salvar"}
            color="orange"
            handleClick={onSave}
          />
        </ModalFooter>
      </ModalPanel>
    </>
  )
}

export default GPTModalScreen
